module.exports = __webpack_public_path__ + "img/news.62c8c360.png";